<template>
  <div>
    <div
      class="passworld"
      :class="{
        typewriter: typewriter,
        deleteTypewriter: deleteTypewriter,
      }"
    >
      <div>
        <p v-html="message"></p>
        <br />
        <p></p>
      </div>
    </div>
  </div>
</template>

<script>
import { delay } from "@/variables.js";
import MainMixinVue from "./utilities/MainMixin.vue";
export default {
  name: "LandingPage",
  data() {
    return {
      message: ".....",
      typewriter: true,
      deleteTypewriter: false,
    };
  },
  mixins: [MainMixinVue],
  mounted() {
    delay(500).then(() => {
      (this.typewriter = false), (this.deleteTypewriter = true);
      delay(1000).then(() => {
        this.message = "requesting resource, status...";
        this.deleteTypewriter = false;
        this.typewriter = true;
        delay(2000).then(() => {
          delay(500).then(() => {
            if (this.$cookies.get("is_fellow") == null) {
              if (this.isMobile) this.message = this.message + "<br/>";
              this.message = this.message + " 404_not_found";
              delay(1000).then(() => {
                this.$router.push("/error");
              });
            } else {
              this.typewriter = false;
              this.deleteTypewriter = true;
              delay(1000).then(() => {
                this.$router.push("/spaceship");
              });
            }
          });
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/landing-error.scss";
.passworld {
  position: relative;
  top: 50vh;
}
</style>
